import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Newer browsers can return a Promise here; never return it from effect.
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
